import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

import Navbar from "./Navbar";
import Footer from "../Footer";
import CarDetailSlider from "./CarDetailSlider";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import Heart from "react-heart";
import { toTitleCase } from "../helper/formatCarName";

import { useNavigate } from "react-router-dom";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import StarRating from "./StarRating";
import PageLoader from "./PageLoader";
const ReadMore = ({ text, maxLength }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  const renderText = () => {
    if (isExpanded || text.length <= maxLength) {
      return text;
    }
    return text.slice(0, maxLength) + "...";
  };

  return (
    <div className="carDescription">
      <div dangerouslySetInnerHTML={{ __html: renderText() }} />
      {text.length > maxLength && (
        <span
          onClick={toggleReadMore}
          style={{ color: "#00889c", cursor: "pointer" }}
        >
          {isExpanded ? " Read Less" : " Read More"}
        </span>
      )}
    </div>
  );
};
const Cardetail = () => {
  const [data, setData] = useState([]);
  const [unlock, setUnlock] = useState(false);
  const [isMakeOffer, setMakeOffer] = useState(false);
  const [isMyCar, setIsMyCar] = useState(false);
  const [buyerName, setBuyerName] = useState("");
  const [buyerEmail, setBuyerEmail] = useState("");
  const [buyerPhone, setBuyerPhone] = useState("");
  const [buyerRequest, setBuyerRequest] = useState("");
  const [bidValue, setBidValue] = useState("");
  const [errors, setErrors] = useState([]);
  const [errorData, setErrorData] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const optionToast = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
  };
  // Validation states
  const [touchedFields, setTouchedFields] = useState({
    buyerName: false,
    buyerEmail: false,
    buyerPhone: false,
    bidValue: false,
    buyerRequest: false,
  });

  // Handle validation on blur (field loses focus)
  const handleBlur = (field) => {
    setTouchedFields({
      ...touchedFields,
      [field]: true,
    });
  };

  // Validate if field is empty and touched
  const getFieldClass = (fieldValue, fieldName) => {
    return !fieldValue && touchedFields[fieldName] ? "is-invalid" : "";
  };
  const location = useLocation();

  // const carDetails = location.state && location.state.carDetails;
  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };
  const storedUserPreferences = getDataFromlocalStorage("userData");

  // const [MyCredit, setMyCredit] = useState(0);
  const [likeStatus, setLikeStatus] = useState(false);

  function formatEuroAmount(amount) {
    const parts = amount.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
  async function fetchedDetail(slug) {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/car/detail",
        {
          user_id: storedUserPreferences?.id,
          slug: slug,
        }
      );
      if (response?.data?.status) {
        setData(response?.data?.data);
        var carData = response?.data?.data;
        // console.log(response?.data?.data);
        if (carData?.isFav === true) {
          setLikeStatus(true);
        } else {
          setLikeStatus(false);
        }
        if (carData?.isOffered === true && storedUserPreferences?.id) {
          console.log(`[Offer Validation] Active offer confirmed for user_id: ${storedUserPreferences.id}, car_id: ${carData.id}`);
          setMakeOffer(true);
        } else {
          setMakeOffer(false);
        }
        if (storedUserPreferences?.id === carData?.owner_id) {
          setIsMyCar(true);
        } else {
          setIsMyCar(false);
        }
      } else {
        // console.log(response?.data);
        setErrorData(response?.data?.message);
        setLoading(false);
      }
    } catch (error) {
      setErrorData(
        error.response?.data?.message || "Failed to fetch car details"
      );
      setLoading(false);
    }
  }
  useEffect(() => {
    // alert();
    const searchParams = new URLSearchParams(location.search);
    const slug = searchParams.get("car");

    if (!slug) {
      setErrorData("Car slug is missing in the URL.");
      setLoading(false);
      return;
    }
    fetchedDetail(slug);
    setBuyerEmail(storedUserPreferences?.email);
    setBuyerPhone(storedUserPreferences?.phone);
    setBuyerName(storedUserPreferences?.first_name);
  }, [location.search]);

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  function convertCcToLiters(cc) {
    if (cc > 0) {
      return (cc / 1000).toFixed(1);
    } else {
      return 0;
    }
  }

  const handleBidChange = (e) => {
    let inputVal = e.target.value;

    // Allow numbers and a single decimal point
    inputVal = inputVal.replace(/[^0-9.]/g, '');

    // If there's more than one decimal point, keep only the first one
    const parts = inputVal.split('.');
    if (parts.length > 2) {
      inputVal = parts[0] + '.' + parts.slice(1).join('');
    }

    // Limit to 2 decimal places
    if (parts.length === 2 && parts[1].length > 2) {
      inputVal = parts[0] + '.' + parts[1].slice(0, 2);
    }

    setBidValue(inputVal);
  };

  const getDisplayBidValue = () => {
    if (!bidValue) return "";
    const parts = bidValue.split('.');
    // Format the integer part with commas
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join('.');
  };

  const handleClick = () => {
    if (!storedUserPreferences?.id) {
      Swal.fire({
        title: "",
        text: "You need to be logged in to unlock a car.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00889C",
        cancelButtonColor: "#d33",
        confirmButtonText: "Log In Now",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/login");
        }
      });
      return;
    }
    if (!buyerPhone) {
      toast.error("Please fill in the phone number.", optionToast);

      return; // Stop further execution if phone number is missing
    }
    if (!buyerEmail) {
      toast.error("Please fill in the email address.", optionToast);

      return; // Stop further execution if email address is missing
    }
    if (!isValidEmail(buyerEmail)) {
      toast.error("Please enter a valid email address.", optionToast);

      return; // Stop further execution if email format is invalid
    }
    if (!buyerName.trim()) {
      toast.error("Please fill in your name.", optionToast);
      return;
    }
    if (!buyerRequest) {
      toast.error("Please select your intent.", optionToast);
      return;
    }
    if (!bidValue || parseFloat(bidValue) <= 0) {
      toast.error("Please enter a valid offer value.", optionToast);
      return;
    }
    saveBidData();
  };

  const liveApi =
    window.CARLOCA_API + "/add/bidding";
  const [submitting, setSubmitting] = useState(false);
  const saveBidData = async () => {
    setSubmitting(true);
    try {
      const res = await axios.post(liveApi, {
        user_id: storedUserPreferences?.id,
        car_id: data?.id,
        name: buyerName,
        email: buyerEmail,
        phone: buyerPhone,
        bid_request: buyerRequest,
        amount: bidValue,
      });
      if (res?.data?.status) {
        toast.success("Your offer has been submitted successfully!", optionToast);
        setUnlock(false);
        setBidValue("");
        setBuyerRequest("");
        // Keep contact fields populated from user profile for convenience
        setBuyerEmail(storedUserPreferences?.email || "");
        setBuyerName(storedUserPreferences?.first_name || "");
        setBuyerPhone(storedUserPreferences?.phone || "");
        setMakeOffer(true);
      } else {
        setErrors(res?.data?.errors);
        toast.error(res?.data?.message, optionToast);
      }
    } catch (error) {
      console.error("An error occurred while fetching data.", error);
      toast.error("Something went wrong. Please try again.", optionToast);
    } finally {
      setSubmitting(false);
    }
  };
  function unlockOffer(car) {
    if (!storedUserPreferences?.id) {
      Swal.fire({
        title: "",
        text: "You need to be logged in to unlock a car.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00889c",
        cancelButtonColor: "#d33",
        confirmButtonText: "Log In Now",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/login");
        }
      });
      return;
    }
    let MyCredit = 0;
    const fetchCredit = async () => {
      try {
        const response = await axios.post(
          window.CARLOCA_API + "/get/credits",
          {
            user_id: storedUserPreferences?.id,
          }
        );
        MyCredit = response?.data?.total_credit;

        if (MyCredit < 1 && car?.owner?.role !== "dealer") {
          Swal.fire({
            title: "",
            text: "You don't have enough credits to unlock this car.",
            icon: "warning",
            showCancelButton: false,
            confirmButtonColor: "#00889c",
            confirmButtonText: "Add Credits",
          }).then((result) => {
            if (result.isConfirmed) {
              navigate("/buyplan");
            }
          });
          return;
        }
        setUnlock(!unlock);
      } catch (error) {
        console.error("An error occurred while fetching data.", error);
      }
    };
    fetchCredit();
  }
  const back = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/FilterCarData");
    }
  };

  const likeDislike = async (user_id, card_id) => {
    try {
      const responsed = await axios.post(
        window.CARLOCA_API + "/like-dislike",
        {
          user_id: user_id,
          car_id: card_id,
        }
      );
      // console.log(responsed);
      if (responsed?.data?.status) {
        toast.success(responsed?.data?.message, optionToast);
      } else {
        toast.error(responsed?.data?.message, optionToast);
      }
    } catch (error) {
      console.error("An error occurred while fetching data.", error);
    }
  };
  const handleLike = (cardId) => {
    if (storedUserPreferences !== null) {
      setLikeStatus(!likeStatus);
      likeDislike(storedUserPreferences?.id, cardId);
    } else {
      toast.warning("Please login to add favorite car!", optionToast);
    }
  };
  const formatNumber = (num) => {
    if (!num) return "0";
    if (num >= 10000000) return (num / 10000000).toFixed(2) + "M";
    if (num >= 100000) return (num / 100000).toFixed(2) + "L";
    if (num >= 1000) return (num / 1000).toFixed(1) + "K";
    return num.toString();
  };
  return (
    <>
      <Navbar />
      <div className="cd-page" style={{ overflowX: "hidden" }}>
        {data?.min_price ? (
          <div className="cd-wrapper container pb-4" style={{ overflowX: "hidden" }}>
            {/* Breadcrumb / back row */}
            <div className="d-flex align-items-center justify-content-between mb-3">
              <button className="cd-back-btn" onClick={back}>
                <i className="fa-solid fa-arrow-left me-2"></i>Back
              </button>
              <div className="d-flex align-items-center gap-2">
                {data?.owner?.city && (
                  <span className="cd-location-pill">
                    <i className="fa fa-location-dot me-1"></i>
                    {data?.owner?.city}
                  </span>
                )}
                <div style={{ height: "30px", width: "30px" }}>
                  <Heart
                    isActive={likeStatus}
                    onClick={() => handleLike(data.id)}
                    animationTrigger="both"
                    inactiveColor="#00889c"
                    activeColor="#00889C"
                    animationDuration={0.2}
                  />
                </div>
              </div>
            </div>

            {/* Car title */}
            <h1 className="cd-title">
              {toTitleCase(data?.make)} {toTitleCase(data?.model)}
              {data?.variant ? ` ${toTitleCase(data?.variant)}` : ""}
              <span className="cd-year-badge">{data?.year}</span>
            </h1>

            {/* Two-column layout */}
            <div className="cd-layout">
              {/* LEFT */}
              <div className="cd-left">
                <div className="cd-slider-wrap">
                  <CarDetailSlider data={data?.gallery} image={data?.image} />
                </div>

                {(() => {
                  let parsedBatteryCapacity = null;
                  let parsedElectricRange = null;
                  if (data?.carData && typeof data.carData === "string") {
                    try {
                      const parsedData = JSON.parse(data.carData);
                      const powertrain = parsedData?.Results?.ModelDetails?.Powertrain;
                      if (powertrain) {
                        parsedBatteryCapacity = powertrain.TotalCapacityKwh || powertrain?.EvDetails?.TechnicalDetails?.BatteryDetailsList?.[0]?.TotalCapacityKwh;
                        parsedElectricRange = powertrain.CombinedRangeMiles || powertrain.ElectricRangeMiles || powertrain?.EvDetails?.Performance?.RangeFigures?.RangeTestCycleList?.[0]?.CombinedRangeMiles;
                      }
                    } catch (e) {
                      console.error("Error parsing carData:", e);
                    }
                  }

                  const batteryCapacity = data?.battery_capacity || parsedBatteryCapacity;
                  const electricRange = data?.electric_range || parsedElectricRange;

                  return (
                    <>
                      <div className="cd-spec-strip">
                        <div className="cd-spec-item">
                          <img src="/img/automatic.png" alt="Transmission" />
                          <span>{data?.transmission_type}</span>
                        </div>
                        <div className="cd-spec-item">
                          <img src="/img/speedometer.png" alt="Mileage" />
                          <span>{formatNumber(data?.current_mileage)} mi</span>
                        </div>
                        <div className="cd-spec-item">
                          <img src="/img/fuel.png" alt="Fuel" />
                          <span>{data?.fuel_type}</span>
                        </div>
                        {data?.engine_capacity > 0 && data?.fuel_type?.toLowerCase() !== "electric" && (
                          <div className="cd-spec-item">
                            <img src="/img/engine.png" alt="Engine" />
                            <span>{convertCcToLiters(data?.engine_capacity)}L</span>
                          </div>
                        )}
                        {batteryCapacity && (
                          <div className="cd-spec-item">
                            <i className="fa-solid fa-battery-full me-2" style={{ color: "#00889c", fontSize: "16px" }}></i>
                            <span>{batteryCapacity} kWh</span>
                          </div>
                        )}
                        {electricRange && (
                          <div className="cd-spec-item">
                            <i className="fa-solid fa-plug me-2" style={{ color: "#00889c", fontSize: "16px" }}></i>
                            <span>{electricRange} mi</span>
                          </div>
                        )}
                        <div className="cd-spec-item">
                          <img src="/img/seating.png" alt="Seats" />
                          <span>{data?.seating_capacity} seats</span>
                        </div>
                      </div>

                      <div className="cd-details-card">
                        <h5 className="cd-section-title">
                          <i className="fa-solid fa-circle-info me-2"></i>Vehicle Details
                        </h5>
                        <div className="cd-details-grid">
                          <div className="cd-detail-row">
                            <span className="cd-detail-label">Make</span>
                            <span className="cd-detail-value">{toTitleCase(data?.make)}</span>
                          </div>
                          <div className="cd-detail-row">
                            <span className="cd-detail-label">Model</span>
                            <span className="cd-detail-value">{toTitleCase(data?.model)}</span>
                          </div>
                          <div className="cd-detail-row">
                            <span className="cd-detail-label">Year</span>
                            <span className="cd-detail-value">{data?.year}</span>
                          </div>
                          <div className="cd-detail-row">
                            <span className="cd-detail-label">Colour</span>
                            <span className="cd-detail-value">{data?.color}</span>
                          </div>
                          <div className="cd-detail-row">
                            <span className="cd-detail-label">Body Type</span>
                            <span className="cd-detail-value">{data?.body_type}</span>
                          </div>
                          <div className="cd-detail-row">
                            <span className="cd-detail-label">Fuel</span>
                            <span className="cd-detail-value">{data?.fuel_type}</span>
                          </div>
                          <div className="cd-detail-row">
                            <span className="cd-detail-label">Gearbox</span>
                            <span className="cd-detail-value">{data?.transmission_type}</span>
                          </div>
                          {data?.engine_capacity > 0 && data?.fuel_type?.toLowerCase() !== "electric" && (
                            <div className="cd-detail-row">
                              <span className="cd-detail-label">Engine</span>
                              <span className="cd-detail-value">{convertCcToLiters(data?.engine_capacity)}L</span>
                            </div>
                          )}
                          {batteryCapacity && (
                            <div className="cd-detail-row">
                              <span className="cd-detail-label">Battery Capacity</span>
                              <span className="cd-detail-value">{batteryCapacity} kWh</span>
                            </div>
                          )}
                          {electricRange && (
                            <div className="cd-detail-row">
                              <span className="cd-detail-label">Electric Range</span>
                              <span className="cd-detail-value">{electricRange} miles</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  );
                })()}

                <div className="cd-desc-card">
                  <h5 className="cd-section-title">
                    <i className="fa-solid fa-file-lines me-2"></i>Description
                  </h5>
                  <div className="moreTextshow">
                    <ReadMore text={data?.specifications} maxLength={300} />
                  </div>
                </div>
              </div>

              {/* RIGHT */}
              <div className="cd-right">
                <div className="cd-panel">
                  <div className="cd-price-block">
                    {data?.owner?.role !== "dealer" ? (
                      <>
                        <span className="cd-price-label">Price Range</span>
                        <div className="cd-price">
                          &pound;{formatEuroAmount(data?.min_price)} &ndash; &pound;{formatEuroAmount(data?.max_price)}
                        </div>
                      </>
                    ) : (
                      <>
                        <span className="cd-price-label">Asking Price</span>
                        <div className="cd-price">&pound;{formatEuroAmount(data?.offer_price)}</div>
                      </>
                    )}
                  </div>

                  <hr className="cd-divider" />

                  {data?.owner?.role === "dealer" ? (
                    <Link
                      to="/dealer/store"
                      state={{ owner_id: data?.owner?.id }}
                      className="cd-dealer-link"
                    >
                      <div className="cd-dealer-avatar" style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: 0 }}>
                        <img
                          src={
                            data?.owner?.profile
                              ? `${window.CARLOCA_UPLOADS}/users/${data?.owner?.profile}`
                              : `https://ui-avatars.com/api/?name=${data?.owner?.dealerName || data?.owner?.first_name || "D"}+${data?.owner?.last_name || ""}&background=random`
                          }
                          alt="Dealer"
                          style={{ display: "block", margin: 0, padding: 0, objectFit: "cover" }}
                        />
                      </div>
                      <div className="cd-dealer-info">
                        <span className="cd-dealer-badge">Dealer</span>
                        <span className="cd-dealer-name">{data?.owner?.dealerName || data?.owner?.first_name || "Dealer"}</span>
                        {data?.owner?.phone && (
                          <span className="cd-dealer-phone">
                            <i className="fa fa-phone me-1"></i>{data?.owner?.phone}
                          </span>
                        )}
                      </div>
                      <i className="fa fa-chevron-right ms-auto cd-dealer-arrow"></i>
                    </Link>
                  ) : (
                    <div className="cd-private-seller">
                      <i className="fa-solid fa-user-circle fa-2x me-2" style={{ color: "#00889c" }}></i>
                      <div>
                        <span className="cd-dealer-badge">Private Seller</span>
                        <span className="d-block text-muted" style={{ fontSize: "13px" }}>Contact available after unlock</span>
                      </div>
                    </div>
                  )}

                  {data?.owner?.role === "dealer" && (
                    <div className="cd-rating-row">
                      <StarRating rating={data?.average_rating} />
                      <span className="ms-2 text-muted" style={{ fontSize: "13px" }}>
                        ({data?.average_rating})
                      </span>
                      <Link
                        to="/dealer/store"
                        state={{ owner_id: data?.owner_id }}
                        className="ms-auto cd-see-reviews"
                      >
                        See Reviews
                      </Link>
                    </div>
                  )}

                  <hr className="cd-divider" />

                  <div className={isMyCar ? "d-none" : ""}>
                    {isMakeOffer ? (
                      <div className="cd-offer-sent">
                        <button type="button" disabled className="cd-cta-btn cd-cta-disabled">
                          {data?.owner?.role !== "dealer" ? "Unlock This Car" : "Make an Offer"}
                        </button>
                        <small className="cd-offer-note">
                          <i className="fa-solid fa-clock me-1"></i>
                          Your offer is being reviewed by the seller.
                        </small>
                      </div>
                    ) : (
                      <button
                        type="button"
                        onClick={() => unlock ? setUnlock(false) : unlockOffer(data)}
                        className="cd-cta-btn"
                      >
                        {unlock
                          ? <><i className="fa-solid fa-xmark me-2"></i>Decide Later</>
                          : data?.owner?.role !== "dealer"
                            ? <><i className="fa-solid fa-lock-open me-2"></i>Unlock This Car</>
                            : <><i className="fa-solid fa-handshake me-2"></i>Make an Offer</>
                        }
                      </button>
                    )}
                  </div>

                  {unlock && (
                    <div className="cd-offer-form mt-3">
                      <h6 className="cd-section-title mb-3">
                        <i className="fa-solid fa-envelope-open-text me-2"></i>Your Offer
                      </h6>
                      {!errors || typeof errors !== "object"
                        ? null
                        : Object.keys(errors).map((key) =>
                          errors[key].map((error, index) => (
                            <small key={index} className="d-block text-center text-danger mb-2">{error}</small>
                          ))
                        )}
                      <div className="mb-3">
                        <input
                          className={`form-control cd-form-input ${getFieldClass(buyerName, "buyerName")}`}
                          placeholder="Your Name"
                          type="text"
                          value={buyerName}
                          onChange={(e) => setBuyerName(e.target.value)}
                          onBlur={() => handleBlur("buyerName")}
                        />
                      </div>
                      <div className="mb-3">
                        <input
                          className={`form-control cd-form-input ${getFieldClass(buyerEmail, "buyerEmail")}`}
                          placeholder="Email Address"
                          type="email"
                          value={buyerEmail}
                          onChange={(e) => setBuyerEmail(e.target.value)}
                          onBlur={() => handleBlur("buyerEmail")}
                        />
                      </div>
                      <div className="row mb-3">
                        <div className="col-6">
                          <input
                            className={`form-control cd-form-input ${getFieldClass(buyerPhone, "buyerPhone")}`}
                            placeholder="Phone Number"
                            type="tel"
                            value={buyerPhone}
                            onChange={(e) => setBuyerPhone(e.target.value)}
                            onBlur={() => handleBlur("buyerPhone")}
                          />
                        </div>
                        <div className="col-6">
                          <div className="input-group">
                            <span className="input-group-text cd-input-prefix">
                              <i className="fa-solid fa-sterling-sign"></i>
                            </span>
                            <input
                              className={`form-control cd-form-input ${getFieldClass(bidValue, "bidValue")}`}
                              placeholder="Price Offered"
                              type="text"
                              value={getDisplayBidValue()}
                              onChange={handleBidChange}
                              onBlur={() => handleBlur("bidValue")}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="mb-3">
                        <select
                          className={`form-control cd-form-input ${getFieldClass(buyerRequest, "buyerRequest")}`}
                          value={buyerRequest}
                          onChange={(e) => setBuyerRequest(e.target.value)}
                          onBlur={() => handleBlur("buyerRequest")}
                        >
                          <option value="">Please select your intent</option>
                          <option value="general enquiry">General Enquiry</option>
                          <option value="looking to buy now">Looking To Buy Now</option>
                          <option value="looking to buy in the future">Looking To Buy In The Future</option>
                        </select>
                      </div>
                      <p className="cd-offer-disclaimer">
                        If the seller does not respond within 7 days, your offer will be automatically declined and no credit will be taken.
                      </p>
                      <button
                        onClick={handleClick}
                        type="button"
                        className="cd-cta-btn"
                        disabled={submitting}
                        style={submitting ? { opacity: 0.6, cursor: "not-allowed" } : {}}
                      >
                        {submitting
                          ? <><i className="fa-solid fa-spinner fa-spin me-2"></i>Submitting...</>
                          : <><i className="fa-solid fa-paper-plane me-2"></i>Submit Your Offer</>
                        }
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <PageLoader text="Loading car details..." />
        )}
        <Footer />
      </div>
      <ToastContainer />
    </>
  );
};

export default Cardetail;